import { defineMessages } from 'react-intl';

const commonMessages = defineMessages({
    previewAnimationsButtonLabel: {
        id: 'common.commonMessages.previewAnimationsButtonLabel',
        description: 'Label for the shared button (any page) that plays every animated GIF currently on screen',
        defaultMessage: 'Preview animations'
    },
    pauseAnimationsButtonLabel: {
        id: 'common.commonMessages.pauseAnimationsButtonLabel',
        description: 'Label for the shared button (any page) that pauses every animated GIF currently on screen',
        defaultMessage: 'Pause animations'
    },
    animationsButtonDesignCount: {
        id: 'common.commonMessages.animationsButtonDesignCount',
        description: 'Parenthetical design count appended to the Play/Pause-all-animations button aria-label',
        defaultMessage: '({count, plural, one {# design} other {# designs}})'
    },
    animatedDesignPausedLabel: {
        id: 'common.commonMessages.animatedDesignPausedLabel',
        description: 'Screen-reader-only text equivalent for the visual "GIF" badge shown on a paused animated design',
        defaultMessage: 'Animated design, paused'
    }
});

export default commonMessages;
